import get from 'lodash/get'
import gql from 'graphql-tag'
import { useUseStaticImageQuery } from '../../generated/graphql'

const query = gql`
  query UseStaticImage($identifier: String) {
    staticImage(identifier: $identifier) {
      id
      image
      altText
    }
  }
`

export default function useStaticImage(identifier: string) {
  const { data, loading } = useUseStaticImageQuery({
    variables: { identifier },
  })

  return { staticImage: get(data, 'staticImage') }
}
